import { Routes } from '@angular/router';
import { userRoleAndPermissionGuard } from './common/guards/user-role-and-permission/user-role-and-permission.guard';
import { mfaGuard } from './common/guards/mfa/mfa.guard';

export const routes: Routes = [
  {
    path: 'apply/stationapp',
    loadComponent: () =>
      import(
        './flowpoint-apps/station-app/pages/consumer-registration/consumer-registration.component'
      ).then((x) => x.ConsumerRegistrationComponent),
  },
  {
    path: 'portal/:operatorName',
    loadComponent: () =>
      import('./platform/pages/operator-landing/operator-landing.component').then(
        (x) => x.OperatorLandingComponent,
      ),
  },
  {
    path: 'unsubscribe',
    loadComponent: () =>
      import('./platform/pages/unsubscribe/unsubscribe.component').then(
        (x) => x.UnsubscribeComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./platform/pages/login/login.component').then(
        (x) => x.LoginComponent,
      ),
  },
  {
    path: 'mfa',
    loadComponent: () =>
      import('./platform/pages/mfa/mfa.component').then(
        (x) => x.MfaComponent,
      ),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'platform/home',
    loadComponent: () =>
      import('./platform/pages/home/home.component').then((x) => x.HomeComponent),
    canActivate: [mfaGuard],
  },
  {
    path: 'platform/users',
    loadComponent: () =>
      import('./platform/pages/users/users.component').then((x) => x.UsersComponent),
    canActivate: [mfaGuard, userRoleAndPermissionGuard],
    data: { permissions: ['User.Read'] },
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./common/components/profile/profile.component').then(
        (x) => x.ProfileComponent,
      ),
    canActivate: [mfaGuard],
  },
  {
    path: 'mockappa',
    loadChildren: () =>
      import('./flowpoint-apps/mock-app-a/mock-app-a.routes').then(
        (x) => x.mockAppARoutes,
      ),
    canActivate: [mfaGuard],
  },
  {
    path: 'mockappb',
    loadChildren: () =>
      import('./flowpoint-apps/mock-app-b/mock-app-b.routes').then(
        (x) => x.mockAppBRoutes,
      ),
    canActivate: [mfaGuard],
  },
  {
    path: 'mockappc',
    loadChildren: () =>
      import('./flowpoint-apps/mock-app-c/mock-app-c.routes').then(
        (x) => x.mockAppCRoutes,
      ),
    canActivate: [mfaGuard],
  },
  {
    path: 'stationstatusapp',
    loadChildren: () =>
      import('./flowpoint-apps/station-status-app/station-status-app.routes').then(
        (x) => x.stationStatusRoutes,
      ),
    data: { preload: true },
    canActivate: [mfaGuard],
  },
  {
    path: 'stationapp',
    loadChildren: () =>
      import('./flowpoint-apps/station-app/station-app.routes').then(
        (x) => x.stationAppRoutes,
      ),
    canActivate: [mfaGuard],
  },
  {
    path: 'trashpassapp',
    loadChildren: () =>
      import('./flowpoint-apps/trash-pass-app/trash-pass-app.routes').then(
        (x) => x.trashPassAppRoutes,
      ),
    data: { preload: true },
    canActivate: [mfaGuard],
  },
  {
    path: 'flushingstationapp',
    loadChildren: () =>
      import('./flowpoint-apps/flushing-station-app/flushing-station-app.routes').then(
        (x) => x.flushingStationAppRoutes,
      ),
    canActivate: [mfaGuard],
  },
];
